export const PATIENT_INFO_LOAD_START = 'custom/patient/PATIENT_INFO_LOAD_START';
export const PATIENT_INFO_LOAD_SUCCESS = 'custom/patient/PATIENT_INFO_LOAD_SUCCESS';
export const LINK_TO_CONSUMER = 'custom/patient/LINK_TO_CONSUMER'
export const UNLINK_FROM_CONSUMER = 'custom/patient/UNLINK_FROM_CONSUMER'


const actions = {
    PATIENT_INFO_LOAD_START,
    PATIENT_INFO_LOAD_SUCCESS,
    updateConsumerInfo: (id, consumerInfo) => ({
        type: PATIENT_INFO_LOAD_SUCCESS,
        payload: {id, data: consumerInfo},
    }),
}


export default actions;
